import React, { useContext } from "react";

import { HandlerContext } from "../../../../../lnb/LnbWrapper";

function LectureContainer({ children, menuLink }) {
    const handlerContext = useContext(HandlerContext);

    const handleClickLectureContainer = () => {
        handlerContext.clickMenuTypeCodeLINK(menuLink);
    };

    return (
        <div className="lecturebox clear" onClick={handleClickLectureContainer}>
            {children}
        </div>
    );
}

export default LectureContainer;
